module.exports = __webpack_public_path__ + "a2314fc9/img/share-action-icon.9c12578c.svg";